import { useLayoutEffect, useState } from "react";

export { useMediaQuery };

/**
 * A hook to check if a media query matches.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia}
 */
const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(
    () => typeof window !== "undefined" && window.matchMedia(query).matches
  );

  useLayoutEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = () => setMatches(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [query]);

  return matches;
};
